export default "__VITE_ASSET__12026bda__"